import type { SubscriptionSchedule } from '../utils/subscriptionSchedule';

export type SchedulePreviewId = 'rolling' | 'fixedDay' | 'releaseDates';

// Prototype-only: pack schedules the example subscription can be switched between
export const schedulePreviews: {
  id: SchedulePreviewId;
  label: string;
  schedule: SubscriptionSchedule;
}[] = [{
  id: 'rolling',
  label: 'Rolling',
  schedule: {
    mode: 'rolling'
  }
}, {
  id: 'fixedDay',
  label: 'Fixed day (14th)',
  schedule: {
    mode: 'fixedDay',
    day: 14
  }
}, {
  id: 'releaseDates',
  label: 'Release dates (14 Jan, 14 Jul)',
  schedule: {
    mode: 'releaseDates',
    dates: [{
      month: 1,
      day: 14
    }, {
      month: 7,
      day: 14
    }]
  }
}];

// When the member's held sign-up order was paid, relative to today
export const FIRST_PACK_PAID_DAYS_AGO = 5;
